<template>
  <div>
    <template v-if="links.length > 0">
      <h5>المعلومات المتبقية :</h5>
      <vue-perfect-scrollbar
        :settings="perfectScrollbarSettings"
        style="max-height: 200px"
        class="px-1"
      >
        <ul class="score-list">
          <li class="score-link" v-for="link in links" :key="link.id">
            <router-link
              :to="
                link.link === '/administrative-status'
                  ? getBoardLink
                  : link.link
              "
            >
              <div
                class="d-flex link-wrapper px-1 align-items-center justify-content-between"
              >
                <span>{{ link.name }}</span>
                <div>
                  +
                  <span class="text-info" v-if="link.mark !== 0">
                    {{ link.mark }}%
                  </span>
                  <span v-if="link.mark !== 0 && link.completion_value !== 0"
                    >|</span
                  >
                  <span class="text-success" v-if="link.completion_value !== 0">
                    {{ link.completion_value }}%
                  </span>
                  <feather-icon class="score-link-icon" icon="ArrowLeftIcon" />
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </vue-perfect-scrollbar>
    </template>
    <div style="opacity: 0.7" class="text-success" v-else>
      تم إكمال كل البيانات
      <feather-icon class="ml-50" icon="CheckSquareIcon" />
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapGetters } from "vuex";

export default {
  components: {
    VuePerfectScrollbar,
  },
  props: {
    links: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters("NgoProfile", ["ngoData", "loading"]),
    getBoardLink() {
      if (this.ngoData.legalForm.name_ar === "مؤسسة")
        return "/administrative-status/trustees-board";
      else return "/administrative-status/administration-council";
    },
  },
  data() {
    return {
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
      },
    };
  },
};
</script>

<style lang="scss">
.score-list {
  padding: 0px 10px;
}
.score-link {
  padding: 0px;
  list-style: none;
  .link-wrapper {
    padding: 8px 10px;
    transition: all 0.2s ease;
    border-radius: 5px;
    .score-link-icon {
      opacity: 0;
      transition: opacity 0.25s ease;
      margin-left: 10px;
    }
    &:hover {
      .score-link-icon {
        opacity: 1;
      }
      backdrop-filter: brightness(95%);
    }
  }
}
</style>
